import { useFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/form/use-form-validation';
import { RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export interface ResetPasswordForm {
  emailAddress: string;
}

export const useResetPasswordFormValidation = (): {
  emailAddress: RegisterOptions<ResetPasswordForm, 'emailAddress'>;
} => {
  const { t } = useTranslation();
  const formValidationRules = useFormValidation();

  return {
    emailAddress: {
      ...formValidationRules.required({
        field: t('delmonicos-shared-sdk.outputs-user.email-address'),
      }),
      ...formValidationRules.emailPattern({
        field: t('delmonicos-shared-sdk.outputs-user.email-address'),
      }),
    },
  };
};
